<span [innerHTML]="constraintToText(constraint)"></span>
